<template>
  <div class="card-renew">
    <div class="header-layout">
      <img class="avatar" :src="user.avatar" />
      <div class="user-info">
        <div class="username">{{ user.name || user.phone }}</div>
        <div class="care-total-info" v-if="cardQty > 0">
          {{ cardQty + "张无忧卡" }}
        </div>
      </div>
    </div>
    <div class="info">
      <div class="card">
        <div class="bg">
          <div class="name">
            {{ name }}
          </div>
          <countdown :time="expireTime" class="date"></countdown>
        </div>
        <div class="l-bg">
          <div class="des">
            <div class="con">
              <div class="card-select" v-if="cards">
                <div
                        class="s-item"
                        @click="selectedCard = c"
                        :class="{ selected: c.id == selectedCard.id }"
                        v-for="c in cards"
                        :key="c.id"
                >
                  <span class="name">{{ c.name }}</span>
                  <span class="money">{{ c.salePrice }}</span>
                  <span class="oth"
                  >折合{{
                      (c.salePrice / c.duration).toFixed(2)
                    }}元/个月</span
                  >
                  <i class="r-time">{{ c.duration }}个月</i>
                </div>
              </div>
              <div
                class="card-word"
                v-if="selectedCard && selectedCard.services"
              >
                <div
                  class="item"
                  v-for="sitem in selectedCard.services.slice(0,expandStatus?selectedCard.services.length:2)"
                  :key="'s-' + selectedCard.id + '-' + sitem.type"
                >
                  <div class="icon">
                    <span><img :src="sitem.icon" /> </span>
                  </div>
                  <div class="text">
                    <div class="name">
                      <span>续费权益</span>{{ sitem.name }}
                    </div>
                    <div class="remark">
                      有效期延长至购买后{{ sitem.duration }}个月
                    </div>
                  </div>
                </div>
                <div class="expand" v-if="selectedCard.services.length > 2" @click="expandStatus =!expandStatus">{{expandStatus?'收起':'展开所有权益'}}<i :class="expandStatus?'ico2':'ico1'"></i></div>
              </div>
            </div>
            <div class="guide">
              <img src="../../assets/care_guide_1.png" />
              <img src="../../assets/care_guide_2.png" />
              <img src="../../assets/care_guide_3.png" />
              <img src="../../assets/care_guide_4.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="con" v-if="selectedCard">
        <div class="pay-money">
          <span class="money"
            >￥{{ selectedCard.salePrice }}
            <i v-if="selectedCard.originPrice > 0"
              ><em>原价</em>￥{{ selectedCard.originPrice }}</i
            >
          </span>
          <span class="view-tk" @click="goAgreement">查看无忧卡服务条款</span>
        </div>
        <y-button class="btn" @click="goPay">立即续费</y-button>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "../../scripts/auth";
import { httpOpen } from "../../scripts/network";
export default {
  name: "Renew",
  data() {
    return {
      isWechat: this.$store.state.isWechat,
      user: {
        name: "",
        phone: "",
        avatar: require("../../assets/ic_default_avatar.png"),
      },
      cardId: "",
      cardType: "",
      cardQty: 0, // 卡数量
      expireTime: null, // 卡的过期时间
      name: null,
      cards: [],
      selectedCard: null, // 当前选中的续费卡
      serviceBase: {
        1: {
          name: "免费贴膜",
          icon: require("../../assets/ic_sticker.png"),
        },
        2: {
          name: "电池更换",
          icon: require("../../assets/ic_battery.png"),
        },
        3: {
          name: "屏幕更换",
          icon: require("../../assets/ic_screen.png"),
        },
        4: {
          name: "整机质保",
          icon: require("../../assets/ic_insurance.png"),
        },
          5: {
              name: "后壳更换",
              icon: require("../../assets/card-qy-type-5.png"),
          },
      },
      prePayResult:null,
      expandStatus:false
    };
  },
  created() {
    this.cardId = this.$route.params.id;
    this.cardType = this.$route.query.type;
    this.name = this.$route.query.name;
    this.expireTime = new Date(parseInt(this.$route.query.time));// 登录重定向将time类型转为了字符串

    this.initUserInfo();
    this.loadMatchRenewCards();
    this.loadCardQty();
  },
  methods: {
    initUserInfo() {
      const info = this.$store.state.userInfo;
      if (!info) {
        // login(this.$store, this.$router);
        return;
      }
      this.user = {
        avatar: info.avatar || require("../../assets/ic_default_avatar.png"),
        name: info.name || "",
        phone: info.phone || "",
      };
    },
    async loadCardQty() {
      try {
        const ret = await httpOpen("/WuYouCard/GetUserCardList", {
          type: "post",
          body: { CustomerMobilePhone: this.user.phone },
        });
        if (ret.Status) {
          this.cardQty = ret.Data && ret.Data.length;
        } else if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
          login(this.$store, this.$router);
          return;
        }
        console.log(ret);
      } catch (e) {
        console.error(e);
      }
    },
    async loadMatchRenewCards() {
      // 获取对应续费卡
      this.$loading.show("正在加载...");
      try {
        const ret = await httpOpen("/WuYouCard/GetRenewalCards", {
          type: "post",
          body: { CardSysNo: this.cardType },
        });
        if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
          login(this.$store, this.$router);
          return;
        } else if (!ret.Status) {
          this.$toast("加载失败，请稍后重试");
        } else {
          this.cards = ret.Data && ret.Data.map(this.cardMapper);
          if (this.cards && this.cards.length > 0) {
            this.selectedCard = this.cards[0]; // 默认选择
          }
        }
        console.log(ret);
      } catch (e) {
        console.error(e);
      } finally {
        this.$loading.hide();
      }
    },
    cardMapper(data) {
      let item = {
        id: data.SysNo,
        type: data.ServiceType,
        name: data.ServiceTypeName,
        salePrice: data.SalesAmount.toFixed(2),
        originPrice: data.DisplayAmount.toFixed(2),
        effectiveDay: data.EffectiveDay,
        duration: Math.floor(data.EffectiveDay / 30),
      };
      item.services =
        data.OrderEquityList && data.OrderEquityList.map(this.serviceMapper);
      return item;
    },
    serviceMapper(item) {
      let service = this.serviceBase[item.EquityType];
      if (!service) {
        service = { name: item.EquityTypeName };
      }
      service.type = item.EquityType;
      service.duration = Math.floor(item.EffectiveDay / 30);
      return service;
    },
    async goPay() {
      // if(!this.isWechat){
      //     this.$toast('请在微信环境支付');
      //     return;
      // }

      if (!this.selectedCard) {
        this.$toast("请选择续费卡");
        return;
      }

      if (this.selectedCard.salePrice <= 0) {
        this.$toast("支付金额不正确");
        return;
      }

      this.$loading.show("正在支付...");
      try {
        const ret = await httpOpen("/WuYouCard/PrePay", {
          type: "post",
          body: {
            OrgCardSysNo: this.cardId,
            NewCardSysNo: this.selectedCard.type,
          },
        });
        if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
          login(this.$store, this.$router);
          return;
        } else if (!ret.Status) {
          this.$toast(ret.Message || "支付失败，请稍后重试");
        } else {
          this.prePayResult = ret.Data;
          this.invokeWechatPay();
          this.$loading.hide();
        }
        console.log(ret);
      } catch (e) {
        console.error(e);
        this.$loading.hide();
      }
    },
    invokeWechatPay() {
      console.log('invokeWechatPay');
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady",this.onBridgeReady,false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
        }
      } else {
        this.onBridgeReady();
      }
    },
    onBridgeReady() {
      console.log('onBridgeReady', this);
      let vm = this;
      window.WeixinJSBridge.invoke("getBrandWCPayRequest", JSON.parse(vm.prePayResult.PayInfo),
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            vm.$router.push({
              name: "RenewPaySuccess",
              params: {
                id: vm.cardId,
              },
              query: {
                amount: vm.selectedCard.salePrice,
                duration: vm.selectedCard.duration,
                day: vm.selectedCard.effectiveDay,
              },
            });
            //window.location.href = (vm.$router.base || '') + "/care/" + vm.cardId +"/renew/pay-result?amount="+ vm.selectedCard.salePrice +"&duration="+ vm.selectedCard.duration +"&day="+vm.selectedCard.effectiveDay;
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              vm.$toast('支付取消');
          } else {
              vm.$toast('支付失败');
          }
        }
      );
    },

    async goAgreement() {
      this.goto(`/agreement?id=${this.selectedCard.type}`);
    }
  },
};
</script>
<style lang="less" scoped>
.card-renew {
  background: #f4f4f4 url("~@/assets/care-head-bg.png") 0 0 no-repeat;
  background-size: 100%;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 60px;
  .header-layout {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 40px 24px 16px 24px;
    .avatar {
      display: block;
      width: 58px;
      height: 58px;
      border-radius: 29px;
      box-sizing: border-box;
      border: 4px solid white;
      margin-right: 8px;
    }
    .user-info {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      flex: 1 1;
    }
    .username {
      color: black;
      font-weight: bold;
      font-size: 16px;
    }
    .care-total-info {
      font-size: 10px;
      color: #fbefd7;
      background: black;
      height: 20px;
      line-height: 20px;
      padding: 0 6px;
      border-radius: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 4px;
    }

    .care-total-info::before {
      content: "";
      display: block;
      background: url("../../assets/ic_star.png") no-repeat top left;
      background-size: 15px 15px;
      width: 15px;
      height: 15px;
    }
  }
  .info {
    .card {
      .bg {
        background: linear-gradient(270deg, #323232, #000000);
        height: 80px;
        margin: 0 16px;
        background-size: 100%;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        display: flex;
        justify-content: space-between;
        .name {
          font-size: 16px;
          font-weight: 600;
          color: #f3dbbf;
          padding-top: 18px;
          padding-left: 18px;
        }
        .date {
          padding-right: 18px;
          font-size: 11px;
          color: #ffffff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .d-name {
            margin-bottom: 9px;
            text-align: right;
          }
          i {
            font-style: normal;
            display: inline-block;
            width: 18px;
            height: 18px;
            text-align: center;
            line-height: 18px;
            background: #e2e2e2;
            border-radius: 2px;
            color: #000;
            margin: 0 2px;
          }
        }
      }
      .l-bg {
        background: url("~@/assets/card-renew-hd-bg.png") 0 0 no-repeat;
        background-size: 100%;
        margin-top: -10px;
        padding-top: 10px;
        .des {
          background-color: #fff;
          .con {
            padding: 10px 16px;
            .card-word {
              .item {
                display: flex;
                margin-bottom: 20px;
                .icon {
                  margin-right: 12px;
                  span {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    width: 38px;
                    height: 38px;
                    border-radius: 100%;
                    background: linear-gradient(
                      325deg,
                      rgba(50, 50, 50, 0.84) 8%,
                      rgba(0, 0, 0, 0.84) 92%
                    );
                    text-align: center;
                    img {
                      max-width: 50%;
                      display: inline-block;
                    }
                  }
                }
                .text {
                  .name {
                    font-size: 14px;
                    font-weight: 600;
                    span {
                      color: #c49254;
                      margin-right: 2px;
                    }
                  }
                }
                .remark {
                  color: #666;
                  font-size: 13px;
                }
              }
              .expand{
                font-size: 14px;
                color: #000000;
                margin-left: 50px;
                font-weight: 600;
                display: flex;
                align-items: center;
                i{
                  display: inline-block;
                  margin-left: 5px;
                  &.ico1{
                    border-top: 6px solid #000;
                    border-left: 4px solid transparent;
                    border-right: 4px solid transparent;
                  }
                  &.ico2{
                    border-bottom: 6px solid #000;
                    border-left: 4px solid transparent;
                    border-right: 4px solid transparent;
                  }
                }
              }
            }
            .card-select {
              display: flex;
              flex-direction: row;
              overflow-y: auto;
              padding-top: 10px;
              &::-webkit-scrollbar { width: 0 !important }
              .s-item {
                background: #f4e3c8;
                border-radius: 6px;
                box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.12);
                padding: 13px 12px;
                display: flex;
                flex-direction: column;
                margin-bottom: 15px;
                position: relative;
                box-sizing: border-box;
                flex: 0 0 auto;
                &:not(:first-child){
                  margin-left: 10px;
                }
                &.selected {
                  background: linear-gradient(360deg, #21242a, #373b42);
                  .name {
                    color: #fff;
                  }
                  .money {
                    color: #ffd8a8;
                  }
                  .oth {
                    color: #FFD8A8;
                    background-color: #484D57;
                  }
                }
                .name {
                  font-size: 15px;
                  font-weight: 600;
                  color: #000000;
                  margin-bottom: 6px;
                }
                .money {
                  font-size: 23px;
                  color: #7c511d;
                  margin-bottom: 6px;
                  &:before {
                    content: "￥";
                    font-size: 12px;
                  }
                }
                .oth {
                  border-radius: 0px 8px 0px 8px;
                  font-size: 12px;
                  color: #7c511d;
                  padding: 1px 9px;
                  background-color: #EDD3AB;
                }
                .r-time {
                  background: linear-gradient(90deg, #6b6766, #404341);
                  border-radius: 0px 8px 0px 8px;
                  display: inline-block;
                  padding: 1px 4px;
                  font-size: 13px;
                  font-weight: 600;
                  font-style: normal;
                  color: #ffe7c0;
                  position: absolute;
                  right: 0;
                  top: -5px;
                }
              }
            }
          }
          .guide {
            padding: 16px;
            background-color: #f4f4f4;
            img {
              display: block;
              width: 100%;
            }
          }
        }
      }
    }
  }
  .bottom {
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    .con {
      padding: 7px 23px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .pay-money {
        display: flex;
        flex-direction: column;
        color: #4f4f4f;
        padding-right: 40px;
        .money {
          font-size: 20px;
          color: #000000;
          i {
            font-size: 13px;
            font-weight: 600;
            color: #888888;
            font-style: normal;
            margin-left: 2px;
            em {
              font-size: 10px;
              font-style: normal;
            }
          }
        }
        .view-tk {
          font-size: 10px;
          color: #000000;
        }
      }
      .btn {
        flex: 1 1;
      }
    }
  }
}
</style>
<style scoped>
.card-renew >>> .y-button {
  background: linear-gradient(90deg, #424242 6%, #2f2f2f 96%);
  color: #ffe0a5;
}
</style>
